
export default function ProductComparisonSection() {
  return (
    <section id="products" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            venturion と smile、どちらを選ぶべき？
          </h2>
        </div>
        
        <div className="overflow-x-auto">
          <table className="w-full bg-white rounded-xl shadow-lg overflow-hidden">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">規模/要求</th>
                <th className="px-6 py-4 text-center text-sm font-semibold text-gray-900">
                  <div className="flex flex-col items-center">
                    <img 
                      src="https://static.readdy.ai/image/2164e1b7672604a4b6f40cc0551a0838/d455e36d544a1f602176bf28e8bcbe52.jfif"
                      alt="ZOLLER smile"
                      className="w-36 h-24 object-cover rounded mb-2"
                    />
                    <span className="text-lg font-bold">smile（スマイル）</span>
                  </div>
                </th>
                <th className="px-6 py-4 text-center text-sm font-semibold text-gray-900">
                  <div className="flex flex-col items-center">
                    <img 
                      src="https://static.readdy.ai/image/2164e1b7672604a4b6f40cc0551a0838/0f3eb76082bd864cb6d35c282fd1ea2d.jfif"
                      alt="ZOLLER venturion"
                      className="w-36 h-24 object-cover rounded mb-2"
                    />
                    <span className="text-lg font-bold">venturion（ベンチュリオン）</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              <tr>
                <td className="px-6 py-4 font-medium text-gray-900">用途</td>
                <td className="px-6 py-4 text-center text-gray-600">エントリー〜中核、まず試し削りゼロ化</td>
                <td className="px-6 py-4 text-center text-gray-600">最短で一発良品と自動化の要</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="px-6 py-4 font-medium text-gray-900">精度レンジ</td>
                <td className="px-6 py-4 text-center text-gray-600">高精度（±2 µm級の実績あり）</td>
                <td className="px-6 py-4 text-center text-gray-600">超高精度（±2 µm以内の繰返し 温度変動下実績）</td>
              </tr>
              <tr>
                <td className="px-6 py-4 font-medium text-gray-900">測定範囲</td>
                <td className="px-6 py-4 text-center text-gray-600">長さ・径・振れが中心</td>
                <td className="px-6 py-4 text-center text-gray-600">角度・コーナーRなど多次元も一括</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="px-6 py-4 font-medium text-gray-900">接続性</td>
                <td className="px-6 py-4 text-center text-gray-600">NCデータ転送対応</td>
                <td className="px-6 py-4 text-center text-gray-600">NCデータ転送対応・自動化セル拡張が容易</td>
              </tr>
              <tr>
                <td className="px-6 py-4 font-medium text-gray-900">代表メリット</td>
                <td className="px-6 py-4 text-center">
                  <span className="inline-block bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-sm font-medium">
                    投資回収が早い・現場に即浸透
                  </span>
                </td>
                <td className="px-6 py-4 text-center">
                  <span className="inline-block bg-black text-white px-3 py-1 rounded-full text-sm font-medium">
                    段取り・品質の上限を引き上げる
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <div className="mt-8 text-center">
          <p className="text-sm text-gray-500">
            注：実効精度や到達時間は機上精度・環境・ワーク条件に依存します。
          </p>
        </div>
      </div>
    </section>
  );
}
